"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "addKeyboard", {
  enumerable: true,
  get: function get() {
    return _layouts.addKeyboard;
  }
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactSimpleKeyboard = _interopRequireDefault(require("react-simple-keyboard"));

require("react-simple-keyboard/build/css/index.css");

var _layouts = require("./layouts");

var _I18n = require("./locale/I18n");

require("./main.css");

var _StringUtil = _interopRequireDefault(require("./util/StringUtil"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var localizableKeyCaps = ['{bksp}', '{lock}', '{shift}', '{tab}'];
/**
 * Returns the localized key caps
 */

function localizeKeyCaps() {
  var localized = {};
  localizableKeyCaps.forEach(function (key) {
    localized[key] = (0, _I18n.i18n)('keyboard.'.concat(key));
  });
  return localized;
}
/* borrowed from https://github.com/facebook/react/issues/10135 */

/**
 * Set the value of a form field such that it can handle the change itself
 *
 * @param {HTMLInputElement} element
 * @param {*} value
 */


function setNativeValue(element, value) {
  switch (element.tagName.toLowerCase()) {
    case 'input':
      {
        var valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
        var prototype = Object.getPrototypeOf(element);
        var prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

        if (valueSetter && valueSetter !== prototypeValueSetter) {
          prototypeValueSetter.call(element, value);
        } else {
          valueSetter.call(element, value);
        }

        element.dispatchEvent(new Event('input', {
          bubbles: true
        }));
        break;
      }

    default:
      {
        throw new Error('Don\'t have a setNativeValue handler for tag', element.tagName);
      }
  }
}
/*
  See react-simple-keyboard documentation at:
  https://franciscohodge.com/projects/react-simple-keyboard/documentation/
*/


var baseKeyboardProps = Object.freeze({
  preventMouseDownDefault: true,
  tabCharOnTab: false,
  theme: 'hg-theme-default ifly-keyboard-theme',
  physicalKeyboardHighlight: true,
  mergeDisplay: true
});

var Kiosk = /*#__PURE__*/function (_Component) {
  _inherits(Kiosk, _Component);

  var _super = _createSuper(Kiosk);

  function Kiosk(props) {
    var _this;

    _classCallCheck(this, Kiosk);

    _this = _super.call(this, props);

    _this.handleKeyPress = function (button) {
      var onSubmit = _this.props.onSubmit;

      if (button === '{tab}') {
        _this.focusNextField();
      } else if (button === '{tab}' && onSubmit) {
        onSubmit();
      } else if (button === '{lock}') {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            capsLock: !prevState.capsLock
          });
        });
      } else if (button === '{shift}') {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            shift: !prevState.shift
          });
        });
      } else {
        // this is a key that will affect the field value
        var _this$state = _this.state,
            focus = _this$state.focus,
            shift = _this$state.shift;
        var _focus$id = focus.id,
            id = _focus$id === void 0 ? '' : _focus$id,
            _focus$name = focus.name,
            name = _focus$name === void 0 ? '' : _focus$name;

        var field = _this.selectField(id || name);

        var fieldValue = field.value,
            selectionStart = field.selectionStart,
            selectionEnd = field.selectionEnd;
        var newValue;
        var newCursorPosition;

        switch (field.tagName.toLowerCase()) {
          case 'input':
            {
              if (button === '{bksp}') {
                if (selectionStart !== selectionEnd) {
                  // delete the selected portion
                  newValue = fieldValue.substr(0, selectionStart).concat(fieldValue.substr(selectionEnd));
                  field.selectionStart = selectionStart;
                  field.selectionEnd = selectionStart;
                  newCursorPosition = selectionStart;
                } else if (selectionStart > 0) {
                  // delete the character at the insertion point
                  newValue = fieldValue.substr(0, selectionStart - 1).concat(fieldValue.substr(selectionStart));
                  newCursorPosition = selectionEnd - 1;
                } else {
                  // backspace at beginning of input has no effect
                  newValue = fieldValue;
                  newCursorPosition = 0;
                }
              } else {
                if (field.maxLength < 1 || fieldValue.length < field.maxLength) {
                  var character = button === '{space}' ? ' ' : button; // insert the character at the selection point (deleting any selected characters in the process).

                  newValue = fieldValue.substr(0, selectionStart).concat(character).concat(fieldValue.substr(selectionEnd));
                  field.selectionStart = 0;
                  field.selectionEnd = 0;
                  newCursorPosition = selectionStart + 1;
                } else {
                  newValue = fieldValue; // enforce max-length by ignoring excess characters

                  newCursorPosition = field.maxLength;
                }
              } // capitalize the first word after a space


              if (button === '{space}') {
                _this.setShiftAuto(field);
              } else if (shift) {
                // shift should only apply to one key
                _this.setState(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    shift: false
                  });
                });
              }

              break;
            }

          default:
            {
              throw new Error('Don\'t have a keypress handler for tag', field.tagName);
            }
        } // this isn't strictly necessary, but let's keep the keyboard's internal
        // value in sync with what we processed here


        _this.keyboard.setInput(newValue, id || name); // delay this so that the event is fully processed before we send events
        // to the form field


        setTimeout(function () {
          // set the input field value. We do it this way so that any native or React
          // event handlers will trigger naturally
          setNativeValue(field, newValue); // set the cursor to the new position

          field.selectionStart = newCursorPosition;
          field.selectionEnd = newCursorPosition;
        }, 0);
      }
    };

    _this.handleFieldClick = function (_ref) {
      var target = _ref.target;
      var id = target.id,
          name = target.name,
          value = target.value;

      _this.setKeyboardInput({
        id: id,
        name: name,
        value: value
      });
    };

    _this.handleFocus = function (_ref2) {
      var target = _ref2.target;
      var id = target.id,
          name = target.name,
          value = target.value;

      if (name) {
        _this.setKeyboardInput({
          name: name,
          value: value
        });
      } else if (id) {
        _this.setKeyboardInput({
          id: id,
          value: value
        });
      } // we have two blocks of code that will indirectly trigger this.setState in rapid succession,
      // and the state will be overridden. We introduce a timeout to prevent that.


      if (value === '' && target.dataset.kioskAutoCapitalize) {
        _this.setShift(true);
      } else {
        // this is important because handleKeyPress will reset after one keypress
        //  if shift is true, triggering a render
        _this.setShift(false);
      }

      if (target.select) {
        target.select();
      }

      if (target.scrollIntoView) {
        // in kiosk mode, the keyboard covers the bottom of the screen so
        // we scroll to keep above the keyboard
        var keyboardElem = document.querySelector('#Keyboard');
        var keyboardTop = keyboardElem.getBoundingClientRect().top;
        var targetBoundingClientRect = target.getBoundingClientRect();

        if (targetBoundingClientRect.bottom > keyboardTop) {
          // element.scrollTo doesn't seem to work,
          // and element.scrollIntoView is too aggressive
          window.scrollBy({
            left: 0,
            top: targetBoundingClientRect.bottom - keyboardTop + 25,
            behavior: 'smooth'
          });
        }
      }
    };

    _this.timeout = undefined;
    _this.keyboard = undefined;
    _this.state = {
      focus: undefined,
      shift: false,
      capsLock: false
    };
    return _this;
  }

  _createClass(Kiosk, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          containerSelector = _this$props.containerSelector,
          ref = _this$props.ref,
          container = document.querySelector(containerSelector);
      if (ref) ref(this);
      this.initializeFields();
      this.focusNextField();
      if (container) container.classList.add('with-keyboard');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          containerSelector = _this$props2.containerSelector,
          ref = _this$props2.ref;

      if (ref) {
        ref(null);
      }

      clearTimeout(this.timeout);
      this.keyboard = undefined; // de-register all event listeners

      var fields = this.selectFields();
      var listeners = this.fieldEventListeners();

      var _loop = function _loop(i) {
        var field = fields[i];
        Object.entries(listeners).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              key = _ref4[0],
              listener = _ref4[1];

          field.removeEventListener(key, listener);
        });
      };

      for (var i = 0; i < fields.length; i += 1) {
        _loop(i);
      }

      var ct = document.querySelector(containerSelector);
      if (ct) ct.classList.remove('with-keyboard');
    }
    /**
     * Set the shift state
     */

  }, {
    key: "setShift",
    value: function setShift() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          shift: state
        });
      });
    }
    /**
     * If the element has data-kiosk-auto-capitalize on, then we
     * set shift
     * @param {HTMLInputElement} field
     */

  }, {
    key: "setShiftAuto",
    value: function setShiftAuto(field, state) {
      if (field && field.dataset.kioskAutoCapitalize) {
        this.setShift(state);
      }
    }
    /**
     * Sets the keyboard input to a given field and its value
     * @param {{name, value}} param0
     */

  }, {
    key: "setKeyboardInput",
    value: function setKeyboardInput(_ref5) {
      var _this2 = this;

      var id = _ref5.id,
          name = _ref5.name,
          value = _ref5.value;

      if (this.keyboard) {
        this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            focus: {
              id: id,
              name: name,
              value: value
            }
          });
        });
        this.keyboard.setInput(value, id || name);
      } else {
        // in case the keyboard hasn't yet been initialized, we need to stall
        this.timeout = setTimeout(function () {
          return _this2.setKeyboardInput({
            id: id,
            name: name,
            value: value
          });
        }, 100);
      }
    }
    /**
     * Get the input element that is currently focused
     */

  }, {
    key: "getFocusedInput",
    value: function getFocusedInput() {
      var formId = this.props.formId,
          _this$state$focus = this.state.focus;
      _this$state$focus = _this$state$focus === void 0 ? {} : _this$state$focus;
      var name = _this$state$focus.name;
      return formId && name ? document.querySelector("#".concat(formId, " input[name='").concat(name, "']")) : {};
    }
    /**
     * The meat of the functionality is right here. This function handles many different scenarios for
     * various keypresses, better than the default handler for react-simple-keyboard.
     */

  }, {
    key: "determineLanguage",
    value: function determineLanguage() {
      var _this$context$locale = this.context.locale,
          locale = _this$context$locale === void 0 ? 'en' : _this$context$locale;

      var _locale$split = locale.split('-'),
          _locale$split2 = _slicedToArray(_locale$split, 1),
          language = _locale$split2[0];

      return language;
    }
    /**
     * A map of the events that we listen to, and their respective handlers
     */

  }, {
    key: "fieldEventListeners",
    value: function fieldEventListeners() {
      return {
        focus: this.handleFocus,
        click: this.handleFieldClick
      };
    }
    /**
     * Select a form field by name
     * @param {string} name
     */

  }, {
    key: "selectField",
    value: function selectField(name) {
      var fields = this.selectFields();
      var result;

      for (var i = 0; i < fields.length; i += 1) {
        if (fields[i].id === name || fields[i].name === name) {
          result = fields[i];
          break;
        }
      }

      return result;
    }
    /**
     * Select all the fields contained within the form
     */

  }, {
    key: "selectFields",
    value: function selectFields() {
      var formId = this.props.formId;
      var formElement = document.getElementById(formId);

      if (!formElement) {
        throw new Error('Could not locate form element specified by formId', formId);
      }

      var elements = [].concat(_toConsumableArray(formElement.getElementsByTagName('input')), _toConsumableArray(formElement.getElementsByTagName('select'))).filter(function (field) {
        return field.type !== 'hidden';
      }).sort(function (a, b) {
        return a.tabIndex - b.tabIndex;
      });
      return elements;
    }
    /**
     * Initialize all the form fields to work with the kiosk keyboard
     */

  }, {
    key: "initializeFields",
    value: function initializeFields() {
      // register my event listeners
      var fields = this.selectFields();
      var listeners = this.fieldEventListeners();

      var _loop2 = function _loop2(i) {
        var field = fields[i];
        Object.entries(listeners).forEach(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 2),
              key = _ref7[0],
              listener = _ref7[1];

          field.addEventListener(key, listener);
        });
      };

      for (var i = 0; i < fields.length; i += 1) {
        _loop2(i);
      }

      if (fields.length) {
        var field0 = fields[0];
        field0.focus(); // this may seem redundant but on component mount, the first field's focus handler may not trigger

        this.handleFocus({
          target: field0
        });
      }
    }
    /**
     * Places focus on the next field after the one that is currently in focus
     */

  }, {
    key: "focusNextField",
    value: function focusNextField() {
      var _this$state$focus2 = this.state.focus;
      _this$state$focus2 = _this$state$focus2 === void 0 ? {} : _this$state$focus2;
      var id = _this$state$focus2.id,
          name = _this$state$focus2.name,
          value = _this$state$focus2.value;
      var formId = this.props.formId;
      var formElement = document.getElementById(formId);

      if (!formElement) {
        throw new Error('Could not locate form element specified by formId', formId);
      }

      var allFields = this.selectFields(); // prioritize the fields that have a tabIndex, then arbitrarily cycle through the
      // non-indexed fields

      var fields = allFields.filter(function (field) {
        return _StringUtil["default"].isNotBlank(field.tabIndex);
      }).concat(allFields.filter(function (field) {
        return _StringUtil["default"].isBlank(field.tabIndex);
      }));
      var nextField = null;

      if (name || id) {
        // first try to match by name, otherwise by value
        var nextIndex = fields.reduce(function (acc, current, index) {
          return _StringUtil["default"].isNotBlank(id) && current.id === id || _StringUtil["default"].isNotBlank(name) && current.name === name ? index + 1 : acc;
        }, null) || fields.reduce(function (acc, current, index) {
          return current.value === value ? index + 1 : acc;
        }, null);

        if (nextIndex) {
          nextField = fields[nextIndex % fields.length];
        }
      } else {
        // no focused field, just focus on the second field
        var _fields = _slicedToArray(fields, 1);

        nextField = _fields[0];
      }

      if (nextField) {
        nextField.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var ref = this.props.ref,
          layouts = (0, _layouts.getLayouts)(),
          layout = layouts[this.determineLanguage()] || layouts["default"],
          _this$state2 = this.state,
          capsLock = _this$state2.capsLock,
          _this$state2$focus = _this$state2.focus;
      _this$state2$focus = _this$state2$focus === void 0 ? {} : _this$state2$focus;

      var inputName = _this$state2$focus.name,
          shift = _this$state2.shift,
          _this$getFocusedInput = this.getFocusedInput(),
          _this$getFocusedInput2 = _this$getFocusedInput.dataset,
          dataset = _this$getFocusedInput2 === void 0 ? {} : _this$getFocusedInput2,
          maxLength = _this$getFocusedInput.maxLength,
          elementInputType = _this$getFocusedInput.type,
          inputType = dataset.inputType || elementInputType,
          dynamicOptions = {
        maxLength: maxLength
      },
          layoutName; // dynamically select a keyboard layout based on the input's type or name


      if ('email' === inputName || 'email' === inputType) {
        layoutName = shift || capsLock ? 'emailShift' : 'email';
      } else if (layout[inputType]) {
        layoutName = inputType;
      } else {
        layoutName = shift || capsLock ? 'shift' : 'default';
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "Keyboard",
        className: "Keyboard ".concat(layoutName)
      }, /*#__PURE__*/_react["default"].createElement(_reactSimpleKeyboard["default"] // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, baseKeyboardProps, dynamicOptions, {
        display: localizeKeyCaps(),
        inputName: inputName,
        keyboardRef: function keyboardRef(r) {
          _this3.keyboard = r;
          if (ref) ref(r);
        },
        onKeyReleased: this.handleKeyPress // We DON'T use onChange because it doesn't do a
        // good job of accounting for the selection point of the cursor
        // We use onKeyReleased instead of onKeyPressed so
        // that certain fields, particularly react-select,
        // don't get their rendering interripted
        // by the blur that happens on release
        ,
        layout: layout,
        layoutName: layoutName
      })));
    }
  }]);

  return Kiosk;
}(_react.Component);

Kiosk.contextType = _I18n.I18nContext;
Kiosk.propTypes = {
  containerSelector: _propTypes["default"].string,
  // the query selector to get the UI's root container.
  // if specified, this element will gain a class "with-keyboard"
  formId: _propTypes["default"].string.isRequired,
  // the HTML ID of the form this kiosk is working on
  onSubmit: _propTypes["default"].func,
  // if the kiosk is allowed to submit the form
  ref: _propTypes["default"].func // a function that will receive a reference to this component's API

};
Kiosk.defaultProps = {
  containerSelector: 'main',
  onSubmit: null,
  ref: null
};
var _default = Kiosk;
exports["default"] = _default;